export enum PermissionType {
    PermissionsView = 0,
    PermissionsEdit = 1,
    ExperienceConfigurator = 2,
    ExperienceEditor = 3,
    ApplicationPrincipalSwap = 4,
    AdminUserView = 5,
    AdminUserEdit = 6,
    AdminUserLockUnlock = 7,
    AdminUserDelete = 8,
    AdminUserPasswordReset = 9,
    AdminUserCreate = 10,
    BrokerApproveReject = 11,
    BClientApproveReject = 12,
    WatchlistView = 13,
    WatchlistEdit = 14,
    DrawWaiveBalance = 15,
}
